export default __webpack_public_path__ + "static/media/gallery_05.6a97512a.jpg";